<template>
  <v-app>
    <SuperiorMenu v-if="this.$route.path != '/login'"> </SuperiorMenu>

    <v-main
      v-if="isMounted"
      :class="has_bottom_drawer ? '' : 'pb-0'"
    >
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import SuperiorMenu from "@/components/layout/SuperiorMenu.vue";

export default {
  name: "App",

  components: {
    SuperiorMenu,
  },

  data: () => ({
    isMounted: false,
  }),

  computed: {
    ...mapState(["selectedItem", "editing"]),
    ...mapState("nodered", ["client"]),

    has_bottom_drawer() {
      return this.editing && this.actualPage()?.global_item_list?.length > 0;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions(["retrieveToken"]),
    ...mapActions("nodered", ["createConnection", "doSubscribe"]),
  },

  async mounted() {
    this.createConnection();
    await this.retrieveToken();
    this.isMounted = true;
  },
};
</script>

<style scoped>
.logo-drawer {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
  justify-content: center;
}

.drawer-list-item {
  margin-bottom: 5px;
}
</style>
